var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStammdaten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63338 9.05866C7.55005 9.05033 7.45005 9.05033 7.35838 9.05866C5.37505 8.99199 3.80005 7.36699 3.80005 5.36699C3.80005 3.32533 5.45005 1.66699 7.50005 1.66699C9.54172 1.66699 11.2 3.32533 11.2 5.36699C11.1917 7.36699 9.61672 8.99199 7.63338 9.05866Z",
    stroke: "#5C5E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 3.33301C15.2916 3.33301 16.5916 4.64134 16.5916 6.24967C16.5916 7.82467 15.3417 9.10801 13.7833 9.16634C13.7167 9.15801 13.6417 9.15801 13.5667 9.16634",
    stroke: "#5C5E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4666 12.133C1.44993 13.483 1.44993 15.683 3.4666 17.0247C5.75827 18.558 9.5166 18.558 11.8083 17.0247C13.8249 15.6747 13.8249 13.4747 11.8083 12.133C9.52494 10.608 5.7666 10.608 3.4666 12.133Z",
    stroke: "#5C5E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2834 16.667C15.8834 16.542 16.4501 16.3003 16.9168 15.942C18.2168 14.967 18.2168 13.3587 16.9168 12.3837C16.4584 12.0337 15.9001 11.8003 15.3084 11.667",
    stroke: "#5C5E64",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStammdaten);
export default __webpack_public_path__ + "static/media/stammdaten.109a1c18d8cd2d11ea20b80566ca83cc.svg";
export { ForwardRef as ReactComponent };